/** Human-readable name for the bridge-backed MCP server passed to ACP agents. */
export const BRIDGE_MCP_SERVER_NAME = 'buildautomaton-bridge';

export const GET_INTEGRATION_CONTENT_TOOL = 'get_integration_content';
export const LIST_PARENT_SESSION_PROMPTS_TOOL = 'list_parent_session_prompts';
export const GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL = 'get_parent_session_turn_transcript';

export const BRIDGE_MCP_TOOL_NAMES = new Set([
  GET_INTEGRATION_CONTENT_TOOL,
  LIST_PARENT_SESSION_PROMPTS_TOOL,
  GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL,
]);

const BRIDGE_MCP_TOOL_LABELS: Record<string, string> = {
  [GET_INTEGRATION_CONTENT_TOOL]: 'Fetch external ticket content',
  [LIST_PARENT_SESSION_PROMPTS_TOOL]: 'List parent session prompts',
  [GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL]: 'Read parent session transcript',
};

/** Strip server prefix from bridge MCP tool names (`buildautomaton-bridge/foo`, `buildautomaton-bridge-foo`). */
export function normalizeBridgeMcpToolName(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '';
  const slash = trimmed.lastIndexOf('/');
  if (slash >= 0) return trimmed.slice(slash + 1).trim().toLowerCase();
  const serverPrefix = `${BRIDGE_MCP_SERVER_NAME}-`;
  if (trimmed.toLowerCase().startsWith(serverPrefix)) {
    return trimmed.slice(serverPrefix.length).trim().toLowerCase();
  }
  return trimmed.toLowerCase();
}

export function resolveBridgeMcpToolDisplayName(rawName: string): string | null {
  const normalized = normalizeBridgeMcpToolName(rawName);
  if (!normalized) return null;
  return BRIDGE_MCP_TOOL_LABELS[normalized] ?? null;
}

/** Cursor and other agents sometimes emit generic MCP tool titles before the real name is known. */
export function isGenericMcpToolTitle(title: string): boolean {
  const t = title.trim().toLowerCase();
  if (!t) return true;
  if (t === 'tool call' || t === 'tool') return true;
  if (t === 'mcp: tool' || t === 'mcp tool') return true;
  return t.startsWith('mcp:') && t.length <= 16;
}

/** Parse permission titles like `buildautomaton-bridge-get_integration_content: get_integration_content`. */
export function resolveBridgeMcpPermissionDisplayTitle(title: string): string | null {
  const trimmed = title.trim();
  if (!trimmed) return null;

  const colonIdx = trimmed.indexOf(':');
  if (colonIdx > 0) {
    const afterColon = trimmed.slice(colonIdx + 1).trim();
    const fromAfter = resolveBridgeMcpToolDisplayName(afterColon);
    if (fromAfter) return fromAfter;
    const fromBefore = resolveBridgeMcpToolDisplayName(trimmed.slice(0, colonIdx));
    if (fromBefore) return fromBefore;
  }

  return resolveBridgeMcpToolDisplayName(trimmed);
}
